import React, { ReactNode } from 'react'
import { SkipLink } from '../atoms'
import logo from '../../assets/images/logo.svg'

interface AuthPageLayoutProps {
  mainId: string
  children: ReactNode
}

// Shared scaffold for the auth pages: dark full-height column, logo header
// (in-flow on mobile, absolute top-left on desktop), and a centered content
// region with a consistent mobile side gutter. The `main` carries the id so a
// single SkipLink target works across pages.
export const AuthPageLayout: React.FC<AuthPageLayoutProps> = ({ mainId, children }) => (
  <div className='bg-black min-h-screen font-primary flex flex-col'>
    <SkipLink targetId={mainId} />
    <header>
      <div className='p-4 md:p-0 md:absolute md:left-[40px] md:top-[40px]'>
        <img src={logo} className='w-[138px]' alt='DopaGE logo' />
      </div>
    </header>
    <main
      id={mainId}
      tabIndex={-1}
      className='flex-1 flex items-center justify-center px-4 md:px-0'
    >
      {children}
    </main>
    <footer className='sr-only' />
  </div>
)

export default AuthPageLayout
